import { useState } from "react";
import { toast } from "sonner";
import { Clock } from "lucide-react";
import { endpoints } from "@/lib/api";
import { PageHeader, Card, Field, Btn, DeleteBtn, Loading, Empty, useCrud, handleErr } from "./AdminUI";

const BLANK = { time: "", showTitle: "", djName: "", order: 0 };

export default function AdminSchedule() {
  const { data: rows, loading, reload } = useCrud(endpoints.schedule);
  const [form, setForm] = useState(BLANK);

  const create = async () => {
    if (!form.time || !form.showTitle) { toast.error("Time and show title required"); return; }
    try { await endpoints.adminCreateSchedule(form); toast.success("Slot added"); setForm(BLANK); reload(); }
    catch (e) { handleErr(e); }
  };
  const del = async (id) => { try { await endpoints.adminDeleteSchedule(id); toast.success("Removed"); reload(); } catch (e) { handleErr(e); } };

  return (
    <div>
      <PageHeader title="Schedule" desc="Manage the daily radio programming grid." />
      <Card className="p-5 mb-6 grid sm:grid-cols-4 gap-3 items-end">
        <Field label="Time slot" value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })} placeholder="06:00 - 09:00" data-testid="schedule-time-input" />
        <Field label="Show title" value={form.showTitle} onChange={(e) => setForm({ ...form, showTitle: e.target.value })} data-testid="schedule-show-input" />
        <Field label="DJ / Host" value={form.djName} onChange={(e) => setForm({ ...form, djName: e.target.value })} />
        <Btn onClick={create} data-testid="schedule-add-btn"><Clock className="w-4 h-4" /> Add slot</Btn>
      </Card>
      {loading ? <Loading /> : rows.length === 0 ? <Empty /> : (
        <Card className="divide-y divide-[#273042]">
          {rows.map((s) => (
            <div key={s.id} data-testid={`admin-schedule-${s.id}`} className="p-4 flex items-center justify-between gap-3">
              <div className="flex items-center gap-4"><span className="font-mono text-sm text-slate-300 w-28">{s.time}</span><div><div className="text-white text-sm font-semibold">{s.showTitle}</div><div className="text-xs text-slate-400">{s.djName}</div></div></div>
              <DeleteBtn onClick={() => del(s.id)} testid={`schedule-delete-${s.id}`} />
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
